import Device from '../Device';
import vp from '../../../services/api/vp';

const questions = [{
  model: 'vpbattery',
  type: 'sim',
  name: 'vpbattery',
}];

const addDevice = async (values, context) => {
  const deviceData = {
    ...values,
    mfg: 'vp-sim',
    deviceType: 'battery',
    kind: 'battery',
    type: null,
    ...Device.commonAddDeviceParameters(context),
  };
  return vp.addDevice(deviceData);
};

const VPBattery = new Device('vpbattery', { mfg: 'vp-sim', questions, addDevice });

export default VPBattery;
